// @ts-ignore
// Ignore because DISABLE_LOGIN is a global variable defined in index.html
export const isLoginDisabled: boolean = window.DISABLE_LOGIN === true;
